import { LegalEntityFormFieldNames } from "features/new-actor/enums/legalEntityFormFieldNames";
import { LegalEntity } from "features/subscription-process/contractualization-process/types/interfaces";

export function isLegalEntity(entity: any): entity is LegalEntity {
  return LegalEntityFormFieldNames.CompanyName in entity && LegalEntityFormFieldNames.CompanyRole in entity;
}
